import appTravelRequest from "../../views/appSettings/travelRequest.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("travelrequest", {
    url: "travelrequest/:id",
    parent: "app",
    views: {
      view: {
        template: appTravelRequest,
      },
    },
    reloadOnSearch: false,
    data: { title: "Travel Request" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/travelRequest/travelRequest.urls.js